import { Injectable } from '@angular/core';
import { Energieart } from '../../domain/model/energieart';

@Injectable({
    providedIn: 'root',
})
export class EnergieartIconService {

    public static readonly DEFAULT_ICON = 'innogy_picto_lightning_n_RGB.png';
    public static readonly ICON_OTHERTYPES = 'innogy_picto_lightning_n_RGB.png';
    public static readonly ICON_WATER = 'innogy_picto_waterdrop_n_RGB.png';
    public static readonly ICON_WIND = 'innogy_picto_windmill_n_RGB.png';
    public static readonly ICON_BHKW = 'innogy_picto_business_small_n_RGB.png';
    public static readonly ICON_PHOTOVOLTAIC = 'innogy_picto_sun_n_RGB.png';
    public static readonly ICON_BIO = 'innogy_picto_leaf_n_RGB.png';

    public getIconNameForEnergieart(energieart: Energieart): string {
        switch (energieart) {
            case Energieart.WIND:
                return EnergieartIconService.ICON_WIND;
            case Energieart.GASE_BIOMASSE:
                return EnergieartIconService.ICON_BIO;
            case Energieart.WASSER:
                return EnergieartIconService.ICON_WATER;
            case Energieart.SOLAR:
                return EnergieartIconService.ICON_PHOTOVOLTAIC;
            case Energieart.BHKW:
                return EnergieartIconService.ICON_BHKW;
            case Energieart.GEOTHERMIE:
                return EnergieartIconService.ICON_BIO;
        }
        return EnergieartIconService.DEFAULT_ICON;
    }
}
